import { EuiCallOut, EuiFlexGroup, EuiTab, EuiTabs } from "@inscopix/ideas-eui";
import { ModalTaskLogsBodyLogs } from "components/ButtonViewTaskLogs/ModalTaskLogsBodyLogs";
import { StepProgress } from "components/StepProgress/StepProgress";
import { useState } from "react";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
import { isNonNullish } from "utils/isNonNullish";
import { isTerminalTaskStatus } from "utils/isTerminalTaskStatus";
import { TabStatusGraphProps } from "../TabStatusGraph/TabStatusGraph";

export const TabLogs = ({
  progress,
}: Pick<TabStatusGraphProps, "progress">) => {
  const [selectedNodeId, setSelectedNodeId] = useState(progress.nodes[0].id);

  const task = progress.nodes.find((n) => n.id === selectedNodeId)?.task;
  return (
    <>
      <EuiTabs size="s">
        {progress.nodes.map((node) => (
          <EuiTab
            key={node.id}
            id={node.id}
            isSelected={selectedNodeId === node.id}
            onClick={() => setSelectedNodeId(node.id)}
          >
            <EuiFlexGroup alignItems="center" gutterSize="s">
              <StepProgress
                stepColors={[colorsByRunStatus[node.status]]}
                size="xs"
              />
              {node.label}
            </EuiFlexGroup>
          </EuiTab>
        ))}
      </EuiTabs>
      {isNonNullish(task) && isTerminalTaskStatus(task.status) ? (
        <ModalTaskLogsBodyLogs
          logsHeightOffset={40}
          key={task.id}
          task={{ ...task, dateCreated: task.date_created }}
        />
      ) : (
        <EuiCallOut>Task info not available</EuiCallOut>
      )}
    </>
  );
};
